import React from "react";
import { VscFilePdf } from "react-icons/vsc";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <nav className="fixed top-0 left-0 z-50 w-full transition ease-linear transform bg-gray-800 shadow-xl md:max-w-4xl lg:max-w-6xl xl:max-w-7xl">
      <div className="flex items-center justify-between w-full h-16 px-3 py-3 text-gray-300 lg:px-5 lg:pl-3">
        <Link to="/">
          <h1 className="ml-2 sm:text-xl">Mansoor CV</h1>
        </Link>
        <a
          href="https://drive.google.com/file/d/1kJcwLl5wbu2DzKBnAFUTh5apjn3flSHQ/view?usp=sharing"
          target={"_blank"}
          rel="noreferrer"
          download
        >
          <VscFilePdf className="w-6 h-6 mr-2 sm:w-8 sm:h-8" />
        </a>
      </div>
    </nav>
  );
};

export default Header;
